// Contract for handing the card data to the same-origin /machine-3ds popup via
// postMessage. The opener opens the popup synchronously on click (so it is not
// popup-blocked) and the popup pulls the data once it is ready. This keeps the
// card data out of the URL and out of any storage at rest.

export const THREE_DS_READY = '3ds-ready'
export const THREE_DS_CARD_DATA = '3ds-card-data'

export type ThreeDsCardPayloadType = {
  consumerUrl: string
  cardNumber: string
  cardExpiry: string
  cardCvv: string
}

export type ThreeDsReadyMessageType = {
  type: typeof THREE_DS_READY
}

export type ThreeDsCardDataMessageType = {
  type: typeof THREE_DS_CARD_DATA
} & ThreeDsCardPayloadType

export type ThreeDsMessageType =
  | ThreeDsReadyMessageType
  | ThreeDsCardDataMessageType
